export default __webpack_public_path__ + "static/media/bbr.3a11051b.svg";